// export const endpoint = "http://www.economicus.kr/v1";
// export const endpoint = "http://127.0.0.1:8080/v1";
export const endpoint = "http://localhost:8080/v1";
